<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div class="bg-white padding-xl" style="position:relative;">
			<div class="padding-tb">
				<router-link tag="a" :to="{ path: 'list' }">
					<Button size="large">
						查看积分明细
					</Button>
				</router-link>
			</div>
			<Divider orientation="left">今日统计</Divider>
			<div style="" class="padding">
				<span class="">今日获得：</span>
				<span class="text-xl text-red">{{info.today.hd.hj}}</span>（{{info.today.hd.sl}}笔）
			</div>
			<div style="" class="padding">
				<span class="">今日支出：</span>
				<span class="text-xl text-red">{{info.today.zc.hj}}</span>（{{info.today.zc.sl}}笔）
			</div>
			<Divider orientation="left">历史统计</Divider>
			<div style="" class="padding">
				<span class="">累计获得：</span>
				<span class="text-xl text-red">{{info.total.hd.hj}}</span>（{{info.total.hd.sl}}笔）
			</div>
			<div style="" class="padding">
				<span class="">累计支出：</span>
				<span class="text-xl text-red">{{info.total.zc.hj}}</span>（{{info.total.zc.sl}}笔）
			</div>
			<Divider orientation="left">现有统计</Divider>
			<div style="" class="padding">
				<span class="">现有积分：</span>
				<span class="text-xl text-red">{{info.now.score}}</span>
			</div>
			<div style="" class="padding">
				<span class="">冻结积分：</span>
				<span class="text-xl text-red">{{info.now.dongjie}}</span>
			</div>
			<Spin fix v-if="loading">
				<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
				<div>处理中...</div>
			</Spin>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				info: {
					today: {
						hd: {},
						zc: {}
					},
					total: {},
					now: {}
				}
			};
		},
		methods: {
			loadinfo() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/client/score/index.php?a=init').then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.info = res.data.data;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			//console.log(this.searchForm)
			this.loadinfo();
		}
	};
</script>

<style>
</style>
